export enum SessionTab {
  Candidates = "Candidates",
  Results = "Results",
  Information = "Information",
}
